var _path, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 30,
    viewBox: "0 0 22 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5625 10.842C21.5625 18.6277 14.6609 26.4141 12.0484 29.0824C11.5032 29.6392 10.6218 29.6392 10.0766 29.0824C7.46429 26.4143 0.5625 18.6284 0.5625 10.842C0.5625 5.6708 4.31235 0.5 11.0621 0.5C17.8119 0.5 21.5617 5.67092 21.5617 10.842H21.5625ZM2.06303 10.842C2.06303 6.34433 5.279 1.97724 11.0629 1.97724C16.8468 1.97724 20.0627 6.34433 20.0627 10.842C20.0627 15.1668 17.6704 19.651 15.0945 23.1848C13.8262 24.9247 12.5553 26.378 11.6013 27.3961C11.4074 27.6029 11.2271 27.7913 11.0629 27.96C10.8987 27.7913 10.7184 27.6029 10.5245 27.3961C9.57052 26.378 8.29967 24.9247 7.03153 23.1848C4.45539 19.6509 2.06303 15.1667 2.06303 10.842ZM15.5628 10.842C15.5628 13.2899 13.5481 15.2743 11.0629 15.2743C8.57764 15.2743 6.56296 13.2899 6.56296 10.842C6.56296 8.39404 8.57764 6.40961 11.0629 6.40961C13.5481 6.40961 15.5628 8.39404 15.5628 10.842ZM17.0627 10.842C17.0627 14.1059 14.3766 16.7517 11.0629 16.7517C7.7492 16.7517 5.06307 14.1059 5.06307 10.842C5.06307 7.57804 7.7492 4.93224 11.0629 4.93224C14.3766 4.93224 17.0627 7.57804 17.0627 10.842Z",
    fill: "#CC000A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.0617,
    cy: 10.8571,
    rx: 6.3,
    ry: 6.21428,
    fill: "#CC000A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.655f42fb7c4ff5ca95967fcb020008e3.svg";
export { ForwardRef as ReactComponent };